interface IToggleEmploymentFormButton {
    onClickChange: () => void;
    text?: string;
}

const ToggleEmploymentFormButton = ({text, onClickChange}: IToggleEmploymentFormButton) => {


    return (
        <>
            {text && text?.length > 0 ? <div className="d-md-flex align-items-start justify-content-md-between mt-4">
                    <p className="w-lg-75 font-italic font-size-sm pr-md-4">{text}</p>
                <div className="d-flex d-md-block justify-content-end">
                    <button className="btn btn-outline-primary" type="button" data-toggle="collapse"
                            onClick={onClickChange} aria-expanded="false">
                        Ändra
                    </button>
                </div>
                </div>
                :
                <div className="d-flex justify-content-sm-end my-4">
                    <button className="btn btn-outline-primary" type="button" data-toggle="collapse"
                            onClick={onClickChange} aria-expanded="false">
                        Ändra
                    </button>
                </div>
            }
        </>
    )

}

export default ToggleEmploymentFormButton